import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const CTASection = () => (
  <section className="bg-gradient-to-br from-[#0f2a5a] to-[#0a1f44] py-16">
    <div className="mx-auto max-w-5xl px-5 text-center md:px-8">
      <h2 className="heading-xl text-3xl text-white md:text-4xl">
        Planning a window control or ventilation project?
      </h2>
      <p className="mx-auto mt-4 max-w-2xl text-base text-blue-100">
        From a single remote window opener to the largest commercial installation, our team is
        ready to help. Get in touch for expert advice and a competitive quotation.
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
        <Link
          to="/contact"
          className="btn-primary inline-flex items-center gap-2 rounded-md px-7 py-3.5 text-sm font-semibold"
        >
          Request a Quote <ArrowRight size={17} />
        </Link>
        <Link
          to="/products"
          className="inline-flex items-center gap-2 rounded-md border border-white/40 px-7 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-white/10"
        >
          View Products
        </Link>
      </div>
    </div>
  </section>
);

export default CTASection;
